import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { getApolloClient } from './apollo-client';
import config from './aws-config';
import './styles.css';

// Wrapper component to conditionally provide Apollo (GraphQL) or use REST fallback
function AppWithApollo() {
  const hasGraphQL = config.graphqlEndpoint && config.graphqlEndpoint.trim() !== '';

  if (!hasGraphQL) {
    console.warn('⚠️ GraphQL endpoint not configured - falling back to REST API');
    return <App />;
  }

  const getToken = async () => {
    // Will be provided by AuthContext
    const user = JSON.parse(sessionStorage.getItem('user') || 'null');
    return user?.token || '';
  };

  const apolloClient = getApolloClient(getToken);

  return (
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppWithApollo />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
